import { render, staticRenderFns } from "./searchMail.vue?vue&type=template&id=632901b2"
import script from "./searchMail.vue?vue&type=script&lang=js"
export * from "./searchMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports